// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1959z","file":"styles_file__1XjGO"};